import type { Recipe as RecipeSchema, WithContext } from 'schema-dts'

import { SeoProps } from '../../components/Seo'
import { Recipe, RecipeStep } from '../../types/fam-graphql'
import { RecipeIngredientsProps } from '../../components/RecipeIngredientsSection'

import { ingredientsListTransformer } from './RecipeIngredients'

export const recipeSeoTransformer = (
  recipe: Recipe | null,
  url: string,
  t: any
): SeoProps => {
  const ingredients = ingredientsListTransformer(
    recipe?.portions ?? 2,
    recipe?.portions ?? 2,
    recipe?.ingredients ?? []
  )

  const recipeIngredient = ingredients.length
    ? ingredients?.map(
        (ingredient: RecipeIngredientsProps) =>
          `${ingredient?.units} ${ingredient?.name}`
      )
    : undefined

  const recipeJsonLd: WithContext<RecipeSchema> = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    name: recipe?.name ?? '',
    image: recipe?.image ?? '',
    prepTime: `PT${recipe?.preparation_time ?? 0}M`,
    cookTime: `PT${recipe?.baking_time ?? 0}M`,
    totalTime: `PT${
      (recipe?.preparation_time ?? 0) + (recipe?.baking_time ?? 0)
    }M`,
    nutrition: {
      '@type': 'NutritionInformation',
      servingSize: '100g',
      calories: `${recipe?.kcal_per_100_g} Kcal` ?? '',
      fatContent: `${recipe?.lipids_per_100_g} g` ?? '',
      carbohydrateContent: `${recipe?.carbohydrates_per_100_g} g` ?? '',
      fiberContent: `${recipe?.fibres_per_100_g} g` ?? '',
      sugarContent: `${recipe?.simple_sugars_per_100_g} g` ?? '',
      sodiumContent: `${recipe?.salt_per_100_g} g` ?? '',
    },
    recipeCategory: recipe?.recipe_category ?? '',
    recipeIngredient,
    recipeInstructions: recipe?.steps?.map((step: RecipeStep, index) => ({
      '@type': 'HowToStep',
      name: `Étape ${index + 1}`,
      text: step?.text?.replace(/<\/?[^>]+(>|$)/g, ''),
      image: step?.image ?? undefined,
    })),
  }

  return {
    title: `${recipe?.name ?? ''} ${t('site_title_suffix')}`,
    description: `${recipe?.name ?? ''} ${t('site_description_suffix')}`,
    jsonLd: [recipeJsonLd],
    url,
    canonical: url,
  }
}
